var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 14",
    style: {
      enableBackground: "new 0 0 12 14"
    },
    xmlSpace: "preserve",
    width: 12,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    fill: "#FFFFFF"
  }, "\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#73BE2F;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,2.25C1.0335,2.25,0.25,3.0335,0.25,4v6c0,0.9665003,0.7835,1.75,1.75,1.75h8 c0.9665003,0,1.75-0.7834997,1.75-1.75V4c0-0.9665-0.7834997-1.75-1.75-1.75H2z M1.75,4.8106599V10 c0,0.1380997,0.11193,0.25,0.25,0.25h8c0.1380997,0,0.25-0.1119003,0.25-0.25V4.8106599L7.2374401,7.8232198 c-0.6834202,0.6834207-1.79146,0.6834207-2.4748802,0L1.75,4.8106599z M9.1893396,3.75H2.8106599l3.0125599,3.0125599 c0.09764,0.09763,0.2559304,0.09763,0.3535604,0L9.1893396,3.75z",
    fill: "#73BE2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.06cfc99893b4f5587f213c5643e07530.svg";
export { ForwardRef as ReactComponent };